<div class="seed-return-add-prod" (window:resize)="onresize($event)">
  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Add Product(s) to the Return
    </h3>

    <div class="form-sec">
      <div class="row margin-r0">
        <div class="col-md-12 col-lg-12 smallPadRgt0">
          <app-cpp-return-filter [filters]="filterTypeList" (SearchFilter)="filterProductGridData($event)" (ClearFilter)="filterProductGridData($event)"></app-cpp-return-filter>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 tabBgColor padding-t20">
      <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
        <mat-tab>

          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>
                Your Account Invoiced Products
              </h4>
              <span *ngIf="!isReturnTypeForInnoculant" class="non-return-prod">
                Show Non-Returnable Product <mat-checkbox (change)="showShipToNonReturnableProducts(!isShipToNonReturnable)" class="custom-checkbox margin-l10" data-testid="chk-non-return-product-account"></mat-checkbox>
              </span>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer accInvProdTable">
            <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info cursor-defualt">
                  <p class="vendorName" [attr.data-testid]="'lbl-vendor-name-account_'+element.itemNumber"> {{element.itemVendorName}}</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                  <p class="red-color-msg" *ngIf="element.displayMessage!=null">
                    Non-Returnable
                  </p>
                </td>
              </ng-container>

              <!--<ng-container matColumnDef="Item Number">
                <th mat-header-cell *matHeaderCellDef class="text-center itemNumber"> Item Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.itemNumber}} </span>
                </td>
              </ng-container>-->
              <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);" [attr.data-testid]="'btn-show-product-account_'+element.itemNumber">
                    <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                  </div>
                </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="Eligible Units">
                <th mat-header-cell *matHeaderCellDef class="text-center eligibleUnits"> Eligible Units </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="!isReturnTypeForInnoculant" [attr.data-testid]="'lbl-eligible-units-account_'+element.itemNumber"> {{element.invoiceUnits - element.totalReturnUnits > 0 ? element.invoiceUnits - element.totalReturnUnits : 0}} </span>
                  <span *ngIf="isReturnTypeForInnoculant" [attr.data-testid]="'lbl-eligible-units-account_'+element.itemNumber"> {{element.invoiceUnits > 0 ? element.invoiceUnits : 0}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSize}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span>
                    {{element.productLine}}
                  </span>
                </td>
              </ng-container>
              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                  <div>
                    <div class="cpp-prod-info mobile-nested-table">
                      <div class="row">
                        <div class="col-md-3">
                        </div>
                        <div class="col-md-6">
                          <table style="width:100%" class="m-0">
                            <thead>
                              <tr>
                                <th width="30%" class="text-left">Item # </th>
                                <th width="40%"> GTIN </th>
                                <th width="30%" class="text-right"> Active Ingredients </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="">
                                <th width="30%" class="d-block d-sm-block d-md-none">Item # </th>

                                <td width="30%" class="text-left"><p [attr.data-testid]="'lbl-item-number-account_'+element.itemNumber">{{element.itemNumber}}</p> </td>
                                <th width="40%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                <td width="40%"><p>{{element.gtin}}</p></td>
                                <th width="30%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                <td width="30%" class="text-right"><p>{{element.activeIngredients}}</p> </td>
                              </tr>
                              <tr *ngIf="element.warningMessage">
                                <td mat-cell class="product-details" colspan="8">
                                  <div class="inline-error red-inline-error m-0">
                                    <div class="row">
                                      <div class="error-msg">{{element.warningMessage}}</div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,true)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab>

          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>
                Parent Company Invoiced Products
              </h4>
              <span *ngIf="!isReturnTypeForInnoculant" class="non-return-prod">
                Show Non-Returnable Product <mat-checkbox (change)="showParentNonReturnableProducts(!isParentNonReturnable)" class="custom-checkbox margin-l10" data-testid="chk-non-return-product-parent-account"></mat-checkbox>
              </span>
            </div>
          </ng-template>

          <div class="tableContainer prodTableContainer compInvProdTable">
            <table mat-table [dataSource]="parentAccountDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="Product Name">
                <th mat-header-cell *matHeaderCellDef class="productNameBlock">Product Name </th>
                <td mat-cell *matCellDef="let element" class="order-info">
                  <p class="vendorName" [attr.data-testid]="'lbl-vendor-name-parent-account_'+element.itemNumber"> {{element.itemVendorName}}</p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                  <p class="red-color-msg" *ngIf="element.displayMessage!=null">
                    Non-Returnable
                  </p>
                </td>
              </ng-container>

              <!--<ng-container matColumnDef="Item Number">
                <th mat-header-cell *matHeaderCellDef class="text-center itemNumber"> Item Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.itemNumber}} </span>
                </td>
              </ng-container>-->

              <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);" [attr.data-testid]="'btn-show-product-parent-account_'+element.itemNumber">
                    <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                  </div>
                </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="Eligible Units">
                <th mat-header-cell *matHeaderCellDef class="text-center eligibleUnits"> Eligible Units </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="!isReturnTypeForInnoculant" [attr.data-testid]="'lbl-eligible-units-parent-account_'+element.itemNumber"> {{element.invoiceUnits - element.totalReturnUnits > 0 ? element.invoiceUnits - element.totalReturnUnits : 0}} </span>
                  <span *ngIf="isReturnTypeForInnoculant" [attr.data-testid]="'lbl-eligible-units-parent-account_'+element.itemNumber"> {{element.invoiceUnits > 0 ? element.invoiceUnits : 0}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Pack Size">
                <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span> {{element.packageSize}} </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Product Line">
                <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                <td mat-cell *matCellDef="let element" class="text-center product-line">
                  <div class="checkBoxOuterBg">
                    <div class="chkboxOuter">
                      <i class="fas fa-check checkShowHide"></i>
                      <mat-checkbox class="custom-checkbox select-all-check hide" [ngModel]="element.IsProductSelected" *ngIf="element.IsProductSelected"></mat-checkbox>
                    </div>
                  </div>
                  <span>
                    {{element.productLine}}
                  </span>
                </td>
              </ng-container>
              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                  <div>
                    <div class="cpp-prod-info mobile-nested-table">
                      <div class="row">
                        <div class="col-md-3">
                        </div>
                        <div class="col-md-6">
                          <table style="width:100%" class="m-0">
                            <thead>
                              <tr>
                                <th width="30%" class="text-left">Item # </th>
                                <th width="40%"> GTIN </th>
                                <th width="35%"> Active Ingredients </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="">
                                <th width="30%" class="d-block d-sm-block d-md-none">Item # </th>
                                <td width="30%" class="text-left"><p [attr.data-testid]="'lbl-item-number-parent-account_'+element.itemNumber">{{element.itemNumber}}</p> </td>
                                <th width="40%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                <td width="40%"><p>{{element.gtin}}</p></td>
                                <th width="30%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                <td width="30%"><p>{{element.activeIngredients}}</p> </td>
                              </tr>
                              <tr *ngIf="element.warningMessage">
                                <td mat-cell class="product-details" colspan="8">
                                  <div class="inline-error red-inline-error m-0">
                                    <div class="row">
                                      <div class="error-msg">{{element.warningMessage}}</div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-3">
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'ineligible-row':(row?.displayMessage!=null),'active':(row?.IsProductSelected)}" (click)="keepRecords(row,false)"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </mat-tab>
        <mat-tab *ngIf="!isReturnTypeForInnoculant">

          <ng-template mat-tab-label>
            <div class="tab-head">
              <h4>
                Manually Enter Products
              </h4>
            </div>
          </ng-template>

          <div class="prodTableContainer">
            <div class="manual-add-prod">
              <div class="top-sec">
                <h4>Manually Add Products:</h4>
                <p>To add each product, fill out the form below and hit create product. To remove manually added product from list, simply click on x button, otherwise each manually created product will be added to your return request.</p>
                <div class="row padding-t10 padding-b20">
                  <div class="col-md-3 mt-2">
                    <button [disabled]="!uomNumber || !manualProductItem" mat-raised-button class="btns" color="primary" (click)="createProduct()" data-testid="btn-create-product">Create Product</button>
                  </div>
                  <div class=" col-md-6 material-select withBordr">
                    <ng-select name="ddlProductItem"
                               [items]="manualProductList"
                               class="custom-select-grower grower-add-drop prodDropdown"
                               [virtualScroll]="true"
                               [(ngModel)]="manualProductItem"
                               bindLabel="itemDescription"
                               bindValue="itemId"
                               placeholder="Product:"
                               [closeOnSelect]="true"
                               [searchFn]="productSearchFn"
                               (change)="getUOMByItemNumber($event)"
                               (clear)="getUOMByItemNumber($event)"
                               data-testid="ddl-manual-product-item">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="dropdown-template" [attr.data-testid]="'ddl-manual-product-item-option_'+item.itemNumber">
                          <div class="row">
                            <div class="col-md-10">
                              <p class="name greenColor" [ngOptionHighlight]="search">{{item.itemDescription}}</p>
                              <p class="grower-nos" [ngOptionHighlight]="search">{{item.itemNumber}}, {{item.itemVendorName}}</p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class=" col-md-3 material-select withBordr">
                    <ng-select name="ddlUOM"
                               [items]="uomMasterList"
                               class="custom-select-grower grower-add-drop uomDropdown"
                               [virtualScroll]="true"
                               [(ngModel)]="uomNumber"
                               bindLabel="uom"
                               bindValue="seq"
                               placeholder="UOM:"
                               [closeOnSelect]="true"
                               [searchFn]="filterUOMFn"
                               data-testid="ddl-manual-product-uom">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="dropdown-template" [attr.data-testid]="'ddl-manual-product-uom-option_'+item.uom">
                          <div class="row">
                            <div class="col-md-12">
                              <p class="grower-nos">
                                <span class="grower-gln" [ngOptionHighlight]="search">
                                  {{item.uom}} {{ item.packageSize ? ', ' : ''}} {{item.packageSize}}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="col-md-12 tableContainer manualProdTable">
                  <table mat-table [dataSource]="gridManualProductDataSource" multiTemplateDataRows class="matTables productTable">
                    <ng-container matColumnDef="Product Name">
                      <th mat-header-cell *matHeaderCellDef class="manualAddProdName">Product Name </th>
                      <td mat-cell *matCellDef="let element" class="order-info">
                        <p class="vendorName" [attr.data-testid]="'lbl-vendor-name-manual-product_'+element.itemNumber"> {{element.itemVendorName}}</p>
                        <p class="grower-name">
                          {{element.itemDescription}}
                        </p>
                      </td>
                    </ng-container>

                    <!--<ng-container matColumnDef="Item Number">
                      <th mat-header-cell *matHeaderCellDef class="text-center itemNumber"> Item Number </th>
                      <td mat-cell *matCellDef="let element" class="text-center">
                        <span> {{element.itemNumber}} </span>
                      </td>
                    </ng-container>-->
                    <ng-container matColumnDef="detail">
                      <th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th>
                      <td mat-cell *matCellDef="let element" class="text-center">
                        <div class="showHideDetails text-center md-pt-0" (click)="showProductDetails(element);" [attr.data-testid]="'btn-show-product-manual-product_'+element.itemNumber">
                          <a>{{element.isSelected ? 'Hide Product Details':'View Product Details' }}</a>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="UOM">
                      <th mat-header-cell *matHeaderCellDef class="text-center uom"> UOM </th>
                      <td mat-cell *matCellDef="let element" class="text-center">
                        <p [attr.data-testid]="'lbl-uom-manual-product_'+element.itemNumber"> {{element.uom}} </p>
                      </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="Pack Size">
                      <th mat-header-cell *matHeaderCellDef class="text-center packSize"> Pack Size </th>
                      <td mat-cell *matCellDef="let element" class="text-center">
                        <p> {{element.packageSize}} </p>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="Product Line">
                      <th mat-header-cell *matHeaderCellDef class="text-center prodLine">  Product Line </th>
                      <td mat-cell *matCellDef="let element" class="text-center">
                        <span>
                          {{element.productLine}}
                        </span>
                        <span class="action-btn" (click)="deleteProduct(element)" [attr.data-testid]="'btn-delete-manual-product_'+element.itemNumber">
                          <i class="fas fa-times"></i>
                        </span>
                      </td>
                    </ng-container>
                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                    <ng-container matColumnDef="expandedDetail">
                      <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="manualDisplayedColumns.length" [style.display]="element.isSelected ? 'table-cell' : 'none'">
                        <div>
                          <div class="cpp-prod-info mobile-nested-table">
                            <table style="width:100%" class="m-0">
                              <thead>
                                <tr>
                                  <th width="10%" class="text-left">Item # </th>
                                  <th width="10%"> GTIN </th>
                                  <th width="25%"> Active Ingredients </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="">
                                  <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

                                  <td width="10%" class="text-left"><p [attr.data-testid]="'lbl-item-number-manual-product_'+element.itemNumber">{{element.itemNumber}}</p> </td>
                                  <th width="10%" class="d-block d-sm-block d-md-none"> GTIN </th>
                                  <td width="10%"><p>{{element.gtin}}</p></td>
                                  <th width="25%" class="d-block d-sm-block d-md-none"> Active Ingredients </th>
                                  <td width="25%"><p>{{element.activeIngredients}}</p> </td>
                                </tr>
                                <tr *ngIf="element.warningMessage">
                                  <td mat-cell class="product-details" colspan="8">
                                    <div class="inline-error red-inline-error m-0">
                                      <div class="row">
                                        <div class="error-msg">{{element.warningMessage}}</div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="manualDisplayedColumns;sticky:true;"></tr>
                    <tr mat-row *matRowDef="let row; columns: manualDisplayedColumns;"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="row add-order-sec margin-l0 margin-r0">
    <div class="col-md-2 padding-l0">
      <button mat-raised-button class="btns wide100" color="primary" data-testid="btn-addtoreturn" [disabled]="isProductNotAdded" (click)="addSelectedProductToOrder()">Add To Request</button>
    </div>
    <div class="col-md-2 padding-l0" *ngIf="isShowExportButton()">
      <button mat-raised-button class="btns wide100" color="primary" [disabled]="isDisableExportButton()" (click)="export()" data-testid="btn-export">Export</button>
    </div>
    <div class="col-md-8 text-right m-auto" *ngIf="isShowExportButton()">
      <span class="count">Product selected <span>{{selectedProductList.length}} </span></span>
    </div>
    <div class="col-md-10 text-right m-auto" *ngIf="!isShowExportButton()">
      <span class="count">Product selected <span>{{selectedProductList.length}} </span></span>
    </div>
  </div>
</div>
